import { PrivacyHealthData } from '@/features/consumer/privacy-health-data';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_public/privacy-health-data')(
  {
    component: PrivacyHealthData,
    validateSearch: (search: Record<string, unknown>) => {
      return {
        embed: (search.embed as string) || undefined,
      };
    },
  }
);
